var formatNumber = function formatNumber(value) {
  if (value === null || value === undefined || value === '') return '';
  var numValue = parseInt(String(value).replace(/\D/g, ''), 10);
  if (Number.isNaN(numValue) || numValue < 1000) {
    return '';
  }
  if (numValue >= 1000000) {
    var millions = Math.floor(numValue / 1000000);
    return "+".concat(millions, " M");
  }
  if (numValue >= 100000) {
    var hundredK = Math.floor(numValue / 100000);
    return "+".concat(hundredK * 100, "mil");
  }
  if (numValue >= 5000) {
    var fiveK = Math.floor(numValue / 5000);
    return "+".concat(fiveK * 5, "mil");
  }
  if (numValue >= 1000) {
    return '+1mil';
  }
  return '';
};
export default formatNumber;